export default __webpack_public_path__ + "static/media/moulding.552eec15.jpg";